angular.module("whitelabelApp")
    .controller("RefreshController", ['$scope', '$routeParams', '$location', '$http', 'localStorageService', '$window', function($scope, $routeParams, $location, $http, localStorageService, $window){
        $scope.name = 'RefreshController';
        $scope.params = $routeParams;
        $http.get("/api/session/id").then(function(response){
            if(response.data > 0)
            {
                localStorageService.set('sessionId', response.data);
                $location.path('/Results');
            } else {
                $window.localStorage.clear();
                $location.path('/');
            }
        });
    }]);
    